export default "__VITE_ASSET__DErBNed___"